// SyncedStore connection management for Todo
import { WebsocketProvider } from 'y-websocket'
import { IndexeddbPersistence } from 'y-indexeddb'
import { getYjsDoc } from '@syncedstore/core'
import { setupAwareness, setupHeartbeat } from './awareness'

export let wsProvider: WebsocketProvider | null = null
// IndexedDB provider for offline persistence (assigned in connect function)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let doc: any = null
let idbProvider: IndexeddbPersistence | null = null
// Initialize doc reference
export function initializeDoc(store: any) {
  doc = getYjsDoc(store)
}

export function getDoc() {
  return doc
}

export function getClientId(): number | null {
  if (wsProvider && wsProvider.awareness && typeof wsProvider.awareness.clientID === 'number') {
    return wsProvider.awareness.clientID
  }
  return null
}

// Connection status observable
type ConnectionStatus = 'connected' | 'disconnected'
type StatusListener = (status: ConnectionStatus) => void
let status: ConnectionStatus = 'disconnected'
let listeners: StatusListener[] = []

export function getConnectionStatus() {
  return status
}

export function subscribeConnectionStatus(listener: StatusListener) {
  listeners.push(listener)
  listener(status)
  return () => {
    listeners = listeners.filter(l => l !== listener)
  }
}

function setStatus(newStatus: ConnectionStatus) {
  status = newStatus
  listeners.forEach(l => l(status))
}

export function connect({room, user}: {room?: string, user?: UserSessionJWT} = {}) {


  if (wsProvider) return
  if (!doc || !room) {
    console.error('Doc not initialized. Call initializeDoc first.')
    return
  }
  
  // Use environment variable or fallback to localhost
  const url = import.meta.env.VITE_YJS_WS_URL || 'https://yjs.dev.teclaverde.com'
  wsProvider = new WebsocketProvider(`${url}`, room, doc, {params: {uuid: user?.sid!, firstname: user?.given_name!, lastname: user?.family_name!}})
  
  wsProvider.on('status', (event: { status: string }) => {
    if (event.status === 'connected') {
      console.log('sync connected')
      setStatus('connected')
      setupAwareness({context: 'reconnect', username: user?.name!})
    } else {
      setStatus('disconnected')
      console.log(' sync disconnected')
    }
  })
  
  setStatus((wsProvider as any).wsconnected ? 'connected' : 'disconnected')
  
  // Initial awareness setup
  setupAwareness({context: 'connect', username: user?.name!})


  
  // Wire up IndexedDB persistence for offline support
  idbProvider = new IndexeddbPersistence(room!, doc)

  console.log({idbProvider})
  
  // Setup heartbeat
  setupHeartbeat()
}

export function disconnect() {
  if (wsProvider) {
    try {
      wsProvider.destroy()
      console.log('sync disconnected (destroy called)')
    } catch (e) {
      // ignore
    }
    wsProvider = null
    setStatus('disconnected')
  }
  
  // Clear heartbeat
  if (typeof window !== 'undefined' && (window as any)._clientHeartbeatInterval) {
    clearInterval((window as any)._clientHeartbeatInterval)
    delete (window as any)._clientHeartbeatInterval
  }
  
  // IndexeddbPersistence does not require explicit dispose
  idbProvider = null
}
